import React from 'react';
import { useHistory } from 'react-router-dom';

// import HintModal from "../../containers/hints/hint-modal";
import IconBtn from '../icon-btn/icon-btn';

import CloseIcon from './icon-close.svg';

import './transaction-details.scss';

const TransactionDetailsHeader: React.FC = () => {
  const history = useHistory();
  return (
    <div className="history-details__header">
      <div className="table-header-top">
        <div className="table-header-top__left">
          Детали операции
          {/* <HintModal hint="HISTORY" /> */}
        </div>
        <div className="table-header-top__right">
          <div className="table-header-top__close">
            <IconBtn
              icon={CloseIcon}
              onClick={() => history.push('/history')}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TransactionDetailsHeader;
